import { Option } from "../../util/option";
import { GetCpntPjt } from "../../services/component-projects";

import { DisplayColumn, ErrorMessage } from "../../util/spreadsheet-data-utils";

export type ComponentProjectListPageState = {
  displayColumn: DisplayColumn[];
  dipByRegion: string;
  rootComponentId: string;
  componentId: string;
  pjtStsList: string[];
  projectName: string;
  cpntPjtList: CpntPjtList[];
  generalCode: GeneralCode;
  isEdited: boolean;
  fieldPath: {
    dipByRgn: string;
    rootCpntId: string;
    cpntId: string;
    pjtSts: string;
  };
};

export type SpreadsheetState = {
  cpntPjtList: CpntPjtList[];
  generalCode: GeneralCode;
};

export type CpntPjtList = {
  idx: number;
  isEdited: boolean;
  isChecked: boolean;
  message: string;
  cpntPjt: GetCpntPjt;
  /**
   * for error
   */
  errorColumnList: string[];
  errorMessage: string;
  messageList: ErrorMessage[];
};
export type CpntPjtKeys = keyof GetCpntPjt;
export type GeneralCode = {
  inDefCommonFlagType: Option[];
  tcktStsTypeCpntPrjPrgrs: Option[];
};
export type PageNewState =
  | ComponentProjectListPageState
  | ((
      prevState: ComponentProjectListPageState,
    ) => ComponentProjectListPageState);
